import React from 'react';

const InstagramIcon = ({ width = '40', height = '40' }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    className="fill-current text-techsicoGray-200 hover:text-white hover:shadow-2xl"
  >
    <path
      d="M33.667,60H10.333A8.343,8.343,0,0,1,2,51.667V28.334A8.343,8.343,0,0,1,10.333,20H33.667A8.343,8.343,0,0,1,42,28.334V51.667A8.343,8.343,0,0,1,33.667,60ZM16.417,26.3A8.036,8.036,0,0,0,8.39,34.328V46.374A8.035,8.035,0,0,0,16.417,54.4H27.705a8.035,8.035,0,0,0,8.026-8.026V34.328A8.035,8.035,0,0,0,27.705,26.3Zm11.288,26.04H16.417a5.975,5.975,0,0,1-5.969-5.968V34.328a5.975,5.975,0,0,1,5.969-5.968H27.705a5.975,5.975,0,0,1,5.968,5.968V46.374A5.975,5.975,0,0,1,27.705,52.342Zm-5.819-19.5a7.157,7.157,0,0,0-5,2.051A7.591,7.591,0,0,0,14.6,40.312a7.473,7.473,0,0,0,7.465,7.465,7.347,7.347,0,0,0,5.254-2.19,7.651,7.651,0,0,0,2.21-5.247,7.224,7.224,0,0,0-1.85-5.226A7.727,7.727,0,0,0,22.1,32.847C22.027,32.845,21.956,32.844,21.886,32.844Zm7.82-1.949a1.741,1.741,0,1,0,1.741,1.741A1.743,1.743,0,0,0,29.706,30.9ZM22.061,45.262a4.956,4.956,0,0,1-4.95-4.95A5.064,5.064,0,0,1,18.637,36.7a4.654,4.654,0,0,1,3.251-1.339h.136c3.188.093,5.051,1.933,4.986,4.923A4.987,4.987,0,0,1,22.061,45.262Z"
      transform="translate(-1.5 -19.5)"
    />
  </svg>
);

export default InstagramIcon;
